import { createStore } from 'vuex'

import axios from 'axios'
import router from '@/router';

let user = null;
try {
  user = JSON.parse(localStorage.getItem("user"));
} catch (error) {}


const store = createStore({
    state: {
        user,
        userRole: null,
        reminder: null,
        contactMessages: null,
        token: localStorage.getItem('token') || null,
    },

    mutations:{
        setUser(state, payload){
            state.user = payload
            window.localStorage.user = JSON.stringify(payload);
            console.log('new user login:', state.user)
        },

        // setUserRole(state, payload){
        //     state.userRole = payload
        // },

        saveToken (state, token) {
            state.token = token
            console.log('new user token:', state.token)
          },

        userLogout(state) {
        state.user = null;
        window.localStorage.user = JSON.stringify(null);
        },

        createReminder(state, payload) {
        state.reminder = payload;
        console.log(state.reminder)
        },

        createPrescriptions(state, payload) {
            state.prescriptions = payload;
            console.log(state.prescriptions)
          },

        clientPhone(state, payload) {
        state.clientPhone = payload;
        console.log(state.clientPhone)
        },

        gender(state, payload) {
        state.gender = payload;
        },

        dob(state, payload) {
          state.dob = payload;
        },

        note(state, payload) {
          state.note = payload;
          },

        newContactMessage(state, payload) {
        state.contactMessages = payload;
        },
      
    },

    actions:{
        async createClient(context, {companyName, cacRegNO, companyType, companyAddress, city, state, country,      firstName, lastName, phoneNo, email, password})
        {
            const client_data = await axios.post('/api/v1/clients', {
                "name": companyName, 
                "cac_registration_number": cacRegNO,
                "type": companyType,
                "account": {
                "first_name": firstName,
                "last_name": lastName,
                "phone_number": phoneNo,
                "email": email,
                "password": password,
                "address": {
                "street_address": companyAddress,
                "city": city,
                "state": state,
                "country": country,
                }
                }
            })

            if (client_data){
                console.log(client_data)
                context.commit('setUser', null)
            } else {
                console.log('err')
                throw new Error('could not complete signup')
            }

        },
        

        async loginUser(context, {email, password}){
            const res = await axios.post('/api/v1/login',{
            "email": email,
            "password": password,
            })
            const token = res.headers.authorization
            if (res){
            console.log(res)
            console.log(token) 
            localStorage.setItem('token', token);
            context.commit('saveToken', token)
            } else {
            console.log('err')
            throw new Error('There is a problem with login')
            }

            // const client_details = await axios.get('/api/v1/account/me',)
            //   if(client_details){
            //     console.log(client_details.data.data)
            //     context.commit('setUser', client_details.data.data)
            //     console.log(client_details.data.data.role)
            //   } else {
            //     console.log('err')
            //     throw new Error('could not complete login')
            //     }
                
        },

        async logout(context) {
            context.commit('setUser', null);
            context.commit('saveToken', null);
            window.localStorage.user = JSON.stringify(null);
            window.localStorage.token = JSON.stringify(null);
            router.push("/login")
            // location.reload();
            
          },


        async createReminder(
            context, {phone_number, language, gender, note, date_of_birth, items}
        ){
            const response = await axios.post('/api/v1/prescriptions/initiate',{
                phone_number,
                language,
                gender,
                note,
                date_of_birth,
                items
            });

            const reminder = response.data;
            console.log(reminder)

            if (reminder){
                context.commit('createReminder', reminder);
                router.push('/review-reminder');
            } else {
                throw new Error("Could not set reminder");
              }

        },


        async contactUsMessage(context, { name,  phone_number, email,  message }) {
            const response = await axios.post("/api/v1/contact-us", {
                name,
                phone_number,
                email,
                message 
            });
      
            const contactMessage = response.data;
            let feedback =  response.data.result.message
            console.log(feedback)
      
            if (contactMessage) {
              context.commit("newContactMessage", contactMessage);
            } else {
              throw new Error("Could not sent messsage");
            }
          },



          async createMoreAccount(context, payload) {
            const response = await axios.post(
              "/api/v1/accounts",
              payload
            );
          },

        
          
          
    
    
    },

})


// Export store
export default store







// export default createStore({
//   state: {
//   },
//   getters: {
//   },
//   mutations: {
//   },
//   actions: {
//   },
//   modules: {
//   }
// })
